import { isCustomerAdmin } from "./helpers";
const callsPermissions = {
    calls: {
        index: (_session) => true,
        delete: ({ user, customer }) => isCustomerAdmin(user, customer),
    },
};
export default callsPermissions;
